import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from "@/components/ui/dialog";

const POSITIONS = ["Goalkeeper", "Defender", "Midfielder", "Forward"];

// The Add/Edit Player dialog on Admin — extracted verbatim (no behavior change).
export function PlayerDialog({
  open, onOpenChange, editingPlayerId, playerForm, setPlayerForm, playerError, playerSaving, inputCls,
  onSave, onCancel,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#121212] border-zinc-800 text-white" data-testid="player-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl">{editingPlayerId ? "Edit player" : "Add player"}</DialogTitle>
          <DialogDescription className="text-zinc-500">Enter the player's details and squad status.</DialogDescription>
        </DialogHeader>
        <form onSubmit={onSave} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="font-label text-xs text-zinc-400 block mb-2">First name</label>
              <input required value={playerForm.first_name} onChange={(e) => setPlayerForm({ ...playerForm, first_name: e.target.value })} data-testid="player-firstname" className={inputCls} />
            </div>
            <div>
              <label className="font-label text-xs text-zinc-400 block mb-2">Last name</label>
              <input required value={playerForm.last_name} onChange={(e) => setPlayerForm({ ...playerForm, last_name: e.target.value })} data-testid="player-lastname" className={inputCls} />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="font-label text-xs text-zinc-400 block mb-2">Jersey #</label>
              <input required type="number" min="0" value={playerForm.jersey_number} onChange={(e) => setPlayerForm({ ...playerForm, jersey_number: e.target.value })} data-testid="player-jersey" className={inputCls} />
            </div>
            <div>
              <label className="font-label text-xs text-zinc-400 block mb-2">Position <span className="text-zinc-600 normal-case tracking-normal">(optional)</span></label>
              <select value={playerForm.position} onChange={(e) => setPlayerForm({ ...playerForm, position: e.target.value })} data-testid="player-position" className={inputCls}>
                <option value="" className="bg-[#121212]">— No position —</option>
                {POSITIONS.map((pos) => (
                  <option key={pos} value={pos} className="bg-[#121212]">{pos}</option>
                ))}
              </select>
            </div>
          </div>
          <label className="flex items-center gap-3 cursor-pointer">
            <input type="checkbox" checked={playerForm.active} onChange={(e) => setPlayerForm({ ...playerForm, active: e.target.checked })} data-testid="player-active" className="w-4 h-4 accent-[#CCFF00]" />
            <span className="text-sm text-zinc-300">Active (available to play)</span>
          </label>
          {playerError && <p className="text-[#FF3B30] text-sm" data-testid="player-error">{playerError}</p>}
          <DialogFooter>
            <button type="button" onClick={onCancel} className="font-label text-xs px-4 py-2 text-zinc-400 hover:text-white">Cancel</button>
            <button type="submit" disabled={playerSaving} data-testid="save-player-btn" className="bg-[#CCFF00] text-black font-label text-xs px-5 py-2 rounded-sm hover:bg-[#B3E600] transition-colors duration-150 disabled:opacity-50">
              {playerSaving ? "Saving…" : "Save player"}
            </button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
